var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYourDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1367.986 172.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M46.8,65.552,69.141,21.46H93.6L58.081,86.865V128.54H35.522V87.6L0,21.46H24.609Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.272,74.854q0,26.586-13.183,40.869T150.3,130.005q-24.609,0-37.793-14.282T99.319,74.707q0-26.733,13.221-40.833t37.9-14.1q24.681,0,37.757,14.209T201.272,74.854Zm-78.149,0q0,17.944,6.812,27.026t20.361,9.082q27.173,0,27.173-36.108,0-36.183-27.027-36.182-13.551,0-20.434,9.118T123.123,74.854Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.623,21.46V90.747a39.946,39.946,0,0,1-5.31,20.8,34.56,34.56,0,0,1-15.344,13.7q-10.036,4.763-23.731,4.761-20.654,0-32.08-10.584T219.732,90.454V21.46h22.632V87.012q0,12.378,4.981,18.164t16.479,5.786q11.133,0,16.15-5.822t5.017-18.275V21.46Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.549,87.451V128.54h-22.7V21.46h31.2q21.825,0,32.3,7.947T404.818,53.54a28.415,28.415,0,0,1-5.2,16.809A34.413,34.413,0,0,1,384.9,81.885q24.171,36.108,31.5,46.655H391.2L365.634,87.451Zm0-18.457h7.324q10.767,0,15.894-3.589t5.127-11.279q0-7.617-5.237-10.84t-16.223-3.223h-6.885Z",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.675,73.975q0,26.441-15.051,40.5t-43.47,14.062H462.832V21.46H496.45q26.22,0,40.723,13.843T551.675,73.975Zm-23.584.586q0-34.5-30.469-34.5H485.537V109.79h9.741Q528.089,109.79,528.091,74.561Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.419,128.54l-7.764-25.488H589.617l-7.763,25.488H557.391L595.184,21.021h27.758l37.94,107.519ZM623.235,84.009q-10.766-34.644-12.121-39.185t-1.941-7.178q-2.417,9.376-13.843,46.363Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.566,98.8q0,14.5-10.437,22.851t-29.04,8.35q-17.139,0-30.322-6.445V102.466a124.867,124.867,0,0,0,18.347,6.811,54.255,54.255,0,0,0,13.733,1.978q7.47,0,11.462-2.857t3.992-8.5a9.379,9.379,0,0,0-1.758-5.6,19.669,19.669,0,0,0-5.164-4.725A133.247,133.247,0,0,0,691.5,82.324q-9.816-4.614-14.722-8.862a33.232,33.232,0,0,1-7.837-9.888,28.217,28.217,0,0,1-2.929-13.183q0-14.209,9.631-22.339t26.624-8.13A62.888,62.888,0,0,1,718.2,21.9a109.742,109.742,0,0,1,15.857,5.567l-7.325,17.651a107.127,107.127,0,0,0-14.172-4.907,45.655,45.655,0,0,0-11.023-1.392q-6.446,0-9.888,3a9.907,9.907,0,0,0-3.442,7.837A9.691,9.691,0,0,0,689.6,54.9a15.263,15.263,0,0,0,4.431,4.32q3.037,2.088,14.392,7.508Q723.433,73.9,729,81.116T734.566,98.8Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.72,128.54H816.088V82.324H773.681V128.54H750.976V21.46h22.705V63.428h42.407V21.46H838.72Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.747,21.46h33.325q22.777,0,33.069,6.482t10.29,20.618q0,9.6-4.5,15.747a17.991,17.991,0,0,1-11.974,7.4v.733q10.179,2.27,14.685,8.5t4.5,16.552q0,14.65-10.584,22.852t-28.747,8.2H862.747Zm22.705,42.407h13.183q9.23,0,13.367-2.856t4.138-9.449q0-6.151-4.5-8.825T897.39,40.063H885.452Zm0,18.018V109.79h14.795q9.375,0,13.842-3.589t4.468-10.986q0-13.33-19.043-13.33Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.72,74.854q0,26.586-13.183,40.869t-37.793,14.282q-24.611,0-37.793-14.282T955.767,74.707q0-26.733,13.22-40.833t37.9-14.1q24.681,0,37.757,14.209T1057.72,74.854Zm-78.149,0q0,17.944,6.811,27.026t20.362,9.082q27.172,0,27.173-36.108,0-36.183-27.027-36.182-13.551,0-20.434,9.118T979.571,74.854Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.464,128.54l-7.763-25.488h-39.038L1087.9,128.54h-24.463l37.793-107.519h27.759l37.939,107.519Zm-13.183-44.531q-10.767-34.644-12.122-39.185t-1.941-7.178q-2.417,9.376-13.843,46.363Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.109,87.451V128.54h-22.7V21.46h31.2q21.825,0,32.3,7.947t10.473,24.133a28.408,28.408,0,0,1-5.2,16.809,34.416,34.416,0,0,1-14.721,11.536q24.169,36.108,31.494,46.655h-25.2l-25.561-41.089Zm0-18.457h7.324q10.767,0,15.894-3.589t5.127-11.279q0-7.617-5.238-10.84t-16.222-3.223h-6.885Z",
    style: {
      fill: "#05b758"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.27,73.975q0,26.441-15.052,40.5T1303.75,128.54h-30.323V21.46h33.618q26.22,0,40.723,13.843T1362.27,73.975Zm-23.584.586q0-34.5-30.469-34.5h-12.085V109.79h9.742Q1338.685,109.79,1338.686,74.561Z",
    style: {
      fill: "#05b758"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourDashboard);
export default __webpack_public_path__ + "static/media/Your-Dashboard.57833ca20b53ff2b2066e20da1dccc36.svg";
export { ForwardRef as ReactComponent };